import {
    AVAILABLE_BUILDINGS_REQUEST,
    AVAILABLE_BUILDINGS_SUCCESS,
    AVAILABLE_BUILDINGS_ERROR,
    AVAILABLE_BUILDINGS_SELECT,
} from 'state/actions/available_buildings'

const initialState = {
    loading: false,
    loaded: false,
    buildings: [],
    selectedBuildingIdx: -1,
    errorMessage: '',
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case AVAILABLE_BUILDINGS_REQUEST:
        return {
            ...state,
            loading: true,
            errorMessage: '',
        }
    case AVAILABLE_BUILDINGS_SUCCESS:
        return {
            ...state,
            loading: false,
            loaded: true,
            buildings: action.payload.buildings,
            selectedBuildingIdx: ((action.payload.buildings.length + 1 -
                (action.payload.buildings.length + 1) % 2) / 2 - 1),
        }
    case AVAILABLE_BUILDINGS_ERROR:
        return {
            ...state,
            loading: false,
            loaded: true,
            errorMessage: action.payload.errorMessage,
        }
    case AVAILABLE_BUILDINGS_SELECT:
        return {
            ...state,
            selectedBuildingIdx: action.payload.selectedBuildingIdx,
        }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/available_buildings.js